import { LitElement, html, type TemplateResult } from "lit";

import { customElement, property } from "lit/decorators.js";

import "@phosphor-icons/webcomponents/PhImages";
import "@phosphor-icons/webcomponents/PhLink";
import "@phosphor-icons/webcomponents/PhSealPercent";
import "@phosphor-icons/webcomponents/PhUser";

import { styles } from "./manage-create-modal.css";

import "../manage-create-card/manage-create-card";
import type { DirectiveResult } from "lit/async-directive.js";

@customElement("manage-create-modal")
export class ManageCreateModal extends LitElement {
  static override styles = styles;

  @property({ type: Array })
  manageCreateModalItems: {
    label: DirectiveResult;
    description: DirectiveResult;
    href: string;
    icon: TemplateResult;
  }[] = [];

  private handleManageCreateModalClose() {
    this.dispatchEvent(
      new CustomEvent("manage-create-modal-close", {
        bubbles: true,
        composed: true,
      }),
    );
  }

  override render() {
    return html`<wow-modal
      alternative-close-button
      alternative-background
      variant="responsive"
      @close=${this.handleManageCreateModalClose}
    >
      <span slot="header" class="manage-create-modal-header"><slot name="header"></slot></span>

      <div>
        ${this.manageCreateModalItems.map(
          (item) => html`
            <manage-create-card href=${item.href} title=${item.label} description=${item.description}>
              ${item.icon}
            </manage-create-card>
          `,
        )}
      </div>
    </wow-modal>`;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "manage-create-modal": ManageCreateModal;
  }
}
